<template>
  <div id="wrapper">
    <div id="content-wrapper" class="page">
      <div class="container-fluid">
        <a href="#" @click.prevent="goBack">
          <i class="fas fa-arrow-left"></i> Quay lại
        </a>
        <b-card class="mt-3">
          <b-form autocomplete="off" @submit.prevent="storeItem()">
            <b-row>
              <b-col cols>
                <b-form-group>
                  <i
                    class="fas fa-flag mr-4"
                    v-b-tooltip.hover
                    title="Công việc quan trọng"
                    v-bind:class="{ 'text-muted': item.important == false, 'text-danger': item.important == true }"
                  ></i>

                  <i
                     class="fas fa-calendar-alt mr-4"
                    v-b-tooltip.hover
                    title="Công việc hàng tháng"
                    v-bind:class="{ 'text-muted': item.label == 0, 'text-info': item.label == 1 }"
                  ></i>

                  <!-- <i
                    class="fas fa-flag ml-4 mr-4"
                    v-b-tooltip.hover
                    title="Công việc quan trọng"
                    v-bind:class="{ 'text-muted': item.important == false, 'text-danger': item.important == true }"
                  ></i> -->
                  <span class="mr-4">
                    <b>{{item.name}}</b>
                  </span>
                  <b-badge variant="warning" v-if="item.status == 0" show>
                    <b>Chưa bắt đầu</b>
                  </b-badge>
                  <b-badge variant="info" v-if="item.status == 1" show>
                    <b>Đang thực hiện</b>
                  </b-badge>
                  <b-badge variant="success" v-if="item.status == 2" show>
                    <b>Hoàn thành</b>
                  </b-badge>
                </b-form-group>
              </b-col>
              <b-col cols="2" >
                <!-- Neu la nguoi tao thi hien thi nut Sua - Xoa -->
                <span v-if= "is_empcreated">
                   <b-link class="mr-4" href="#" @click.prevent="editItem" v-if="task_update">
                    <i class="fas fa-edit mr-2"></i> Sửa
                  </b-link>
                  <b-link href="#" @click.prevent="deleteItem" class="text-danger" v-if="task_delete">
                    <i class="fas fa-trash mr-2"></i> Xóa
                  </b-link>
                <!-- <button class="btn btn-primary mb-3" type="submit">Cập nhật</button> -->
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                <b-form-group>
                  <i class="fas fa-user-tie mr-2"></i>
                  <b class="mr-2" v-if="item.empCreated != null">{{item.empCreated.hovaten}}</b>

                </b-form-group>
              </b-col>

              <b-col cols="4">
                <b-form-group>
                  giao cho
                  <b-link
                    href="#"
                    disabled
                    v-if="item.employee != null"
                  > {{"@" + item.employee.hovaten}}</b-link>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="1">
                <b-form-group>
                  <span
                    v-if="item.createdAt != null"
                    class="text-muted"
                  >{{item.createdAt | moment('DD/MM/YYYY')}}</span>
                </b-form-group>
              </b-col>-->
            </b-row>
            <b-row>
              <b-col cols = "2"> <b> Thời hạn:</b>

                <!-- <b-form-group>
                  liên quan
                  <span v-for="(employee, index) in item.employees" :key="employee.id">
                    <span v-if="index != 0">{{", "}}</span>
                    <b-link href="#" disabled>{{"@" + employee.hovaten}}</b-link>
                  </span>
                </b-form-group> -->
              </b-col>
              <b-col cols = "2">
                <div v-if="item.end == null">
                  <b-alert variant="info" show>
                    {{item.start | moment('DD/MM/YYYY')}} - {{item.end | moment('DD/MM/YYYY')}}
                  </b-alert>
                </div>
                <div v-else>
                  <span v-if="new Date(item.end) < Date.now()">
                    <b-alert variant="danger" show>
                      {{item.start | moment('DD/MM/YYYY')}} - {{item.end | moment('DD/MM/YYYY')}}
                    </b-alert>
                  </span>
                  <span v-else>
                     <b-alert variant="info" show>
                      {{item.start | moment('DD/MM/YYYY')}} - {{item.end | moment('DD/MM/YYYY')}}
                     </b-alert>
                  </span>
                </div>
              </b-col>
            </b-row>
            <b-row>
               <b-col>
                <b-form-group label="Nội dung công việc">
                  <template v-slot:label><strong>Nội dung công việc</strong>
                  </template>
                  <b-form-textarea v-if="item.content != null" v-model="item.content" rows="4" max-rows="10" no-auto-shrink></b-form-textarea>
                </b-form-group>
              </b-col>
              <!-- <b-col cols = "2">
                <b> Nội dung công việc: </b>
              </b-col>
              <b-col cols = "10" md="auto">
                <b-form-group>
                  <span v-if="item.content != null">{{item.content}}</span>
                  <span v-if="item.content != null" v-html="item.content"></span>
                  <b-form-textarea v-if="item.content != null" v-model="item.content" rows="5"></b-form-textarea>
                </b-form-group>
              </b-col> -->
            </b-row>

            <b-row v-if="(item.attachs && item.attachs.length)">
              <b-col cols>
                <b-form-group>
                  <i class="fas fa-paperclip mr-2"></i>
                  <span v-for="(attach, index) in item.attachs" :key="attach.id">
                    <span v-if="index != 0">{{", "}}</span>
                    <a :href="attach_url + attach.name" target="_blank">{{attach.name}}</a>
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="commentShow == false">
              <b-col cols>
                <hr />
                <b-form-group>
                  <template v-slot:label>
                    <b-button
                      class="mr-2"
                      variant="outline-secondary"
                      @click.prevent="showCommentLayout"
                    >Phản hồi</b-button>
                    <b-button
                      v-if="item.status == 0"
                      class="mr-2"
                      variant="info"
                      @click.prevent="changeStatus(1)"
                    >Đang thực hiện</b-button>
                    <b-button
                      v-if="item.status < 2"
                      variant="success"
                      @click.prevent="changeStatus(2)"
                    >Hoàn thành</b-button>
                  </template>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="commentShow == true">
              <b-col cols>
                <b-form-group>
                  <b-form-textarea v-model="comment" max-rows="8"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-4" v-if="commentShow == true">
              <b-col>
                <b-form inline>
                  <b-button class="mr-2" variant="primary" @click.prevent="addComment">Gửi</b-button>
                  <b-button
                    class="mr-2"
                    variant="secondary"
                    @click.prevent="hideCommentLayout"
                  >Thoát</b-button>
                  <div style="flex-grow: 1">
                    <b-form-file
                      v-model="commentAttachsfile"
                      placeholder="Nhấn vào đây để thêm tệp đính kèm"
                      browse-text="..."
                      multiple
                    ></b-form-file>
                  </div>
                </b-form>
              </b-col>
            </b-row>
            <!-- orderedComments -->
            <!-- v-for="(comment, index) in item.comments" -->
            <b-row
              v-for="(comment, index) in orderedComments"
              :key="comment.id"
              @mouseover="deleteCommentIndex = index"
              @mouseleave="deleteCommentIndex = -1"
            >
              <b-col cols>
                <b-form-group>
                  <template v-slot:label>
                    <b-form inline>
                      <i v-if= "item.empCreated.id != comment.createdById" class="fas fa-user mr-2"></i>
                      <i v-else class="fas fa-user-tie mr-2"></i>
                      <b v-if="comment.hovaten != null">{{comment.hovaten}}</b>
                      <span
                        class="ml-2 mr-4 text-muted"
                      >{{comment.createdAt | moment('DD/MM/YYYY HH:mm')}}</span>
                      <!-- <div style="flex-grow: 1"></div> -->
                      <div v-show="deleteCommentIndex == index">
                        <b-link
                          href="#"
                          @click.prevent="deleteComment(comment, index)"
                          class="text-danger"
                        >
                          <span v-if= "item.status != 2"><!-- Neu trang thai hoan thanh khong cho xoa comment -->
                            <span v-if= "accountId == comment.createdById"><!-- Neu la nguoi comment moi duoc quyen xoa -->
                              <i  class="fas fa-times"></i>
                            </span>
                          </span>
                        </b-link>
                      </div>
                    </b-form>
                  </template>
                  <!-- Neu nguoi giao màu xanh info/Neu nguoi nhan màu khac-->
                  <!-- <b-badge variant="info"> -->
                    <!-- Nguoi giao xanh duong-->
                    <div v-if= "item.empCreated.id == comment.createdById" class="text-primary">
                      {{comment.comment}}
                    </div>
                    <!-- Nguoi nhan xanh la -->
                    <div v-else class="text-success">
                      {{comment.comment}}
                    </div>
                  <!-- </b-badge> -->


                  <div v-if="(comment.taskCommentAttachs && comment.taskCommentAttachs.length)">
                    <i class="fas fa-paperclip mr-2"></i>
                    <span v-for="(attach, index) in comment.taskCommentAttachs" :key="attach.id">
                      <span v-if="index != 0">{{", "}}</span>
                      <a
                        :href="attach_url + comment.id + '/' + attach.name"
                        target="_blank"
                      >{{attach.name}}</a>
                    </span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from 'lodash';
export default {
  name: "TaskView",
  data() {
    return {
      item: {
        important: false,
        employee: null,
        employees: null,
        start: "",
        end: "",
        name: null,
        content: null,
        attachs: null,
        empCreated: null,
        createdAt: null,
        comments: [],
      },
      attach_url: null,
      comment: "",
      commentShow: false,
      commentAttachsfile: [],
      deleteCommentIndex: -1,
    };
  },
  computed: {
    //Order Ngay Tao comment
    orderedComments: function () {
      return _.orderBy(this.item.comments, 'createdAt', 'desc');
    },
    is_empcreated() {
      return (this.$store.state.auth.accountId == this.item.empCreated.id);
    },
    accountId(){
       return (this.$store.state.auth.accountId);
    },
    task_update() {
      return this.$store.getters.hasPermission("task_update");
    },
    task_delete() {
      return this.$store.getters.hasPermission("task_delete");
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get(`/api/task/${to.params.id}`).then((res) => {
      next((vm) => vm.initData(res.data));
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    initData(item) {
      if (item) {
        this.item = item;
        this.attach_url = `../attach/task/${this.item.id}/`;
      }
    },
    showCommentLayout() {
      this.commentShow = true;
    },
    hideCommentLayout() {
      this.commentShow = false;
    },
    commentMouseOver(index) {
      this.item.comments[index].hover = true;
      // eslint-disable-next-line no-console
      console.log(index);
    },
    commentMouseLeave(index) {
      this.item.comments[index].hover = false;
      // eslint-disable-next-line no-console
      console.log(index);
    },
    addComment() {
      if (!(this.comment && this.comment.length)) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
      } else {
        const formData = new FormData();
        formData.append("taskid", this.item.id);
        formData.append("Comment", this.comment);
        for (let i = 0; i < this.commentAttachsfile.length; i++) {
          formData.append("attachs", this.commentAttachsfile[i]);
        }
        axios
          .post("/api/taskcomment", formData)
          .then((res) => {
            this.comment = "";
            this.commentShow = false;
            this.item.comments.push(res.data);
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          });
      }
    },
    changeStatus(status) {
      const payload = {
        status: status,
        taskId: this.item.id,
      };
      axios
        .put("/api/taskcomment", payload)
        .then((res) => {
          this.item.comments.push(res.data);
          this.item.status = status;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    deleteComment(comment, index) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/taskcomment/${comment.id}`)
                .then((res) => {
                  var i = _.findIndex(this.item.comments,{id: comment.id});
                  this.item.comments.splice(i, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/task/${this.item.id}`)
                .then((res) => {
                  this.$router.go(-1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    editItem() {
      this.$router.push(`/sua_cong_viec/${this.item.id}`);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
